
import vivewBase from './modules/en/vivewBase'
import routerBase from './modules/en/routerBase'
export default {
  ...vivewBase,
  ...routerBase
}
